import React from "react";
import { colors } from "../utils/designTokens";

/**
 * SEC-07: Error Boundary raiz.
 * Captura errores de render en cualquier componente hijo y muestra
 * un mensaje amigable en lugar de pantalla blanca.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("[ErrorBoundary] Error capturado:", error, errorInfo);
    // Enviar a Sentry cuando este instalado (npm install @sentry/react)
    // Por ahora solo logueamos — Sentry se activa agregando REACT_APP_SENTRY_DSN
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
          padding: 32,
          textAlign: "center",
          background: colors.gray50 || "#f8fafc",
        }}>
          <div style={{
            fontSize: 48,
            marginBottom: 16,
          }}>
            ⚠
          </div>
          <h1 style={{
            fontSize: 20,
            color: colors.gray900 || "#1a1a2e",
            marginBottom: 8,
          }}>
            Algo salió mal
          </h1>
          <p style={{
            fontSize: 14,
            color: colors.gray500 || "#64748b",
            marginBottom: 24,
            maxWidth: 400,
          }}>
            Ocurrió un error inesperado. Podés recargar la página para intentar de nuevo.
          </p>
          <button
            type="button"
            onClick={this.handleReload}
            style={{
              padding: "10px 24px",
              fontSize: 14,
              color: "#fff",
              background: colors.primary || "#2563eb",
              border: "none",
              borderRadius: 8,
              cursor: "pointer",
            }}
          >
            Recargar página
          </button>
          {process.env.NODE_ENV === "development" && this.state.error && (
            <pre style={{
              marginTop: 24,
              padding: 16,
              background: colors.gray100 || "#f1f5f9",
              borderRadius: 8,
              fontSize: 12,
              color: colors.error || "#ef4444",
              maxWidth: 600,
              overflow: "auto",
              textAlign: "left",
            }}>
              {this.state.error.toString()}
            </pre>
          )}
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
